import { BoxProps } from '@chakra-ui/react';
import batSvg from 'assets/images/bat-icon.svg?raw';
import ghostSvg from 'assets/images/ghost-icon.svg?raw';
import jackOLanternSvg from 'assets/images/jack-o-lantern-icon.svg?raw';
import mapleLeafSvg from 'assets/images/maple-leaf-icon.svg?raw';
import snowflakeSvg from 'assets/images/RiSnowflakeFill.svg?raw';
import witchHatSvg from 'assets/images/witch-hat-icon.svg?raw';
import wrappedCandySvg from 'assets/images/wrapped-candy-icon.svg?raw';
import config from 'config';
import { IconType } from 'react-icons';
import { LuLeaf, LuSnowflake } from 'react-icons/lu';
import { TbPumpkinScary } from 'react-icons/tb';
import { type SnowfallProps } from 'react-snowfall';

type Variant = NonNullable<typeof config.seasonalEffect>;

type Shape = {
  // Colored by injecting a `fill` on the root <svg>, so the asset must not set one itself.
  svg: string;
  colorTokens: BoxProps['color'][];
};

type VariantConfig = {
  // Snowfall picks a random image per particle, so each color of a shape adds to how often it appears.
  shapes: Shape[];
  icon: IconType;
  snowfall: Pick<SnowfallProps, 'snowflakeCount' | 'speed' | 'wind' | 'radius'>;
};

const variantConfig = {
  winter: {
    shapes: [{ svg: snowflakeSvg, colorTokens: ['white'] }],
    icon: LuSnowflake,
    snowfall: { snowflakeCount: 50, speed: [0.3, 1.0], wind: [-0.5, 1.0], radius: [3.0, 8.0] },
  },
  autumn: {
    shapes: [{ svg: mapleLeafSvg, colorTokens: ['orange.800', 'red.900', 'yellow.800', 'yellow.600'] }],
    icon: LuLeaf,
    snowfall: { snowflakeCount: 10, speed: [0.6, 1.6], wind: [-1.5, 2.0], radius: [10.0, 12.0] },
  },
  halloween: {
    shapes: [
      { svg: ghostSvg, colorTokens: ['whiteAlpha.700'] },
      { svg: jackOLanternSvg, colorTokens: ['orange.600'] },
      { svg: wrappedCandySvg, colorTokens: ['purple.700', 'green.700', 'red.800', 'cyan.800', 'yellow.500'] },
      { svg: batSvg, colorTokens: ['gray.800'] },
      { svg: witchHatSvg, colorTokens: ['gray.700'] },
    ],
    icon: TbPumpkinScary,
    snowfall: { snowflakeCount: 5, speed: [0.2, 2.0], wind: [-0.5, 1.0], radius: [20.0, 25.0] },
  },
} satisfies Record<Variant, VariantConfig>;

const configuredVariant = config.seasonalEffect;

// The env value is only typed, not validated, so an unknown value disables the effect instead of crashing.
export const activeSeasonalEffect = configuredVariant && Object.hasOwn(variantConfig, configuredVariant) ? configuredVariant : undefined;

export const activeSeasonalEffectConfig = activeSeasonalEffect ? variantConfig[activeSeasonalEffect] : undefined;
